import React, { useRef, useState } from 'react';
import ApiService from '../../../../services/apiService';
import '../report.css';
import Select from 'react-select';
import { Modal, Button } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';

const ZReport = () => {
  const [receiptData, setData] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const printRef = useRef();
  const getFormattedDate = (date) => {
    return new Date(date).toISOString().slice(0, 16); // Returns format "YYYY-MM-DDTHH:mm"
  };

  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);

  const [formData, setFormData] = useState({
    fromDate: getFormattedDate(tenDaysAgo),
    toDate: getFormattedDate(today),
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getReportData = async () => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('StartDate', '2025-03-16  00:00:00' || formData?.fromDate);
      params.append('EndDate', '2025-03-16  23:59:00' || formData?.toDate);
      // params.append('StartDate', formData?.fromDate || '2025-03-16  00:00:00');
      // params.append('EndDate', formData?.toDate || '2025-03-16  23:59:00');
      const res = await apiService.getApiParamater('GET_Z_REPORT', `?${params.toString()}`);
      if (res?.data?.result?.length) {
        const groupedData = res.data.result.reduce((acc, curr) => {
          if (!acc[curr.section]) {
            acc[curr.section] = [];
          }
          acc[curr.section].push(curr);
          return acc;
        }, {});

        setGroupedData(groupedData);
        handleLinkClick();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handlePrint = async () => {
    if (!printRef.current) return;

    const canvas = await html2canvas(printRef.current, { scale: 3 });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'px',
      format: 'a4',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position = position - pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save('Z-Report.pdf');
  };
  const handleLinkClick = () => {
    setIsModalVisible(true);
  };
  return (
    <div className="p-5">
      <button className="btn addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="row">
        <div className="col-5">
          <div className="d-flex gap-2">
            <label htmlFor="validationCustom01" className="form-label w-50">
              From Date
            </label>
            <label htmlFor="validationCustom01" className="form-label w-50">
              To Date
            </label>
          </div>
          <div className="d-flex gap-2">
            <input type="date" className="form-control w-75" value={formData?.fromDate} onChange={handleInputChange} name="fromDate" />
            <input type="date" className="form-control w-75" value={formData?.toDate} onChange={handleInputChange} name="toDate" />
          </div>
        </div>
        <div className="col-3 center">
          <label htmlFor="validationCustom01" className="form-label w-50"></label>
          <div className="refbtn center w-50 mt-1" onClick={getReportData}>
            Search
          </div>
        </div>
      </div>
      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)} centered>
        <Modal.Header>
          <div className="receipt-logo center"> Z Report</div>
        </Modal.Header>
        <Modal.Body>
          <div ref={printRef}>
            <div className="receipt-container">
              <div className="receipt-header">
                <div className="receipt-logo">Logo</div>
                <div className="receipt-date">{new Date().toLocaleDateString('en-GB')}</div>
              </div>

              {Object.entries(groupedData).map(([sectionName, items]) => (
                <div key={sectionName} className="section-block">
                  <div className="section-title">{sectionName.toUpperCase()}</div>
                  <hr />
                  {items.map((item, index) => (
                    <div key={index} className="receipt-row">
                      <span>{item?.detail || '-'}</span>
                      <span>{item?.amount?.toFixed(2) || item?.amount?.toFixed(2) || '0.00'}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div onClick={handlePrint} className="refbtn">
            Print PDF
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ZReport;
